// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteSummaryMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteSummaryMutation = { __typename?: 'Mutation', deleteDocumentSummary: number };

export const Operations = {
  Mutation: {
    DeleteSummary: 'DeleteSummary' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const DeleteSummaryDocument = gql`
    mutation DeleteSummary($id: ID!) {
  deleteDocumentSummary(id: $id)
}
    `;
export type DeleteSummaryMutationFn = Apollo.MutationFunction<DeleteSummaryMutation, DeleteSummaryMutationVariables>;

/**
 * __useDeleteSummaryMutation__
 *
 * To run a mutation, you first call `useDeleteSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSummaryMutation, { data, loading, error }] = useDeleteSummaryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSummaryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSummaryMutation, DeleteSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSummaryMutation, DeleteSummaryMutationVariables>(DeleteSummaryDocument, options);
      }
export type DeleteSummaryMutationHookResult = ReturnType<typeof useDeleteSummaryMutation>;
export type DeleteSummaryMutationResult = Apollo.MutationResult<DeleteSummaryMutation>;
export type DeleteSummaryMutationOptions = Apollo.BaseMutationOptions<DeleteSummaryMutation, DeleteSummaryMutationVariables>;